<template>
  <div v-if="responseService">
    <v-container>
      <v-row>
        <v-col cols="12" class="d-flex align-center">
          <v-tooltip v-if="!isAddAffiliateEnabled" bottom>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">
                <v-btn
                  color="primary"
                  rounded
                  class="add-affiliate-btn"
                  :disabled="true"
                >
                  <v-icon left>mdi-account-plus-outline</v-icon>
                  {{ $t('starAssignment.label.assignAffiliates.title') }}
                </v-btn>
              </span>
            </template>
            <span>{{ $t('starAssignment.label.addEmployee.tooltip') }}</span>
          </v-tooltip>
          <v-btn
            v-else
            color="primary"
            rounded
            class="add-affiliate-btn"
            @click="dialog = true"
          >
            <v-icon left>mdi-account-plus-outline</v-icon>
            {{ $t('starAssignment.label.assignAffiliates.title') }}
          </v-btn>
        </v-col>
      </v-row>
      <br />
      <div v-if="showTable">
        <v-row class="global-customization mb-2">
          <v-col cols="12" sm="6" md="3">
            <v-checkbox
              v-model="globalCustomizeShapeType"
              :label="$t('starAssignment.label.customize.type')"
              hide-details
              dense
              @change="toggleGlobalCustomizeShapeType"
            />
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-checkbox
              v-model="globalCustomizeDate"
              :label="$t('starAssignment.label.customize.date')"
              hide-details
              dense
              @change="toggleGlobalCustomizeDate"
            />
          </v-col>
        </v-row>
        <v-row class="table" v-if="checkedAffiliates.length">
          <v-col cols="12">
            <v-card
              v-for="affiliate in checkedAffiliates"
              :key="affiliate.userId"
              class="affiliate-card mb-4"
              elevation="2"
            >
              <v-card-title class="affiliate-title">
                {{ affiliate.firstName }} {{ affiliate.middleName }}
                {{ affiliate.lastName }} {{ affiliate.secondLastName }}
              </v-card-title>

              <v-card-text>
                <v-simple-table class="category-table">
                  <thead>
                    <tr>
                      <th class="text-left" style="color: #6e17a5;">
                        {{ $t('starAssignment.label.table.categories') }}
                      </th>
                      <th class="text-center" style="color: #6e17a5; width: 120px;">
                        {{ $t('starAssignment.label.table.amount') }}
                      </th>
                      <th
                        v-if="globalCustomizeShapeType"
                        class="text-center"
                        style="color: #6e17a5; width: 180px;"
                      >
                        {{ $t('starAssignment.label.typeStar.title') }}
                      </th>
                      <th
                        v-if="globalCustomizeDate"
                        class="text-center"
                        style="color: #6e17a5; width: 180px;"
                      >
                        {{ $t('starAssignment.label.dateMonetization') }}
                      </th>
                      <th class="text-center" style="color: #6e17a5; width: 60px;"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(entry, index) in assignedStars[affiliate.userId] || []"
                      :key="index"
                    >
                      <td>
                        <v-select
                          :label="$t('starAssignment.label.category.title')"
                          :placeholder="$t('starAssignment.label.category.text')"
                          :items="getCategoryOptions(affiliate.userId, index)"
                          item-text="categoryName"
                          return-object
                          color="secondary"
                          :value="entry.categoryObject"
                          @change="handleCategoryChange(affiliate.userId, index, $event)"
                        ></v-select>
                      </td>
                      <td class="text-center">
                        <input
                          type="number"
                          min="0"
                          :value="entry.quantity || ''"
                          class="inputCantidad"
                          :disabled="!entry.categoryName"
                          placeholder="0"
                          @input="updateAssignedStars(affiliate.userId, index, $event.target.value)"
                        />
                      </td>
                      <td
                        v-if="globalCustomizeShapeType"
                        class="text-center"
                      >
                        <v-select
                          v-model="entry.shapeTypeId"
                          :items="typeStar"
                          item-text="name"
                          item-value="id"
                          dense
                          outlined
                          hide-details
                          class="custom-input"
                        ></v-select>
                      </td>
                      <td
                        v-if="globalCustomizeDate"
                        class="text-center"
                      >
                        <v-menu
                          v-model="entry.redeemDateMenu"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          max-width="290px"
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="entry.redeemDate"
                              readonly
                              dense
                              outlined
                              hide-details
                              class="custom-input"
                              color="secondary"
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="entry.redeemDate"
                            color="primary"
                            @change="entry.redeemDateMenu = false"
                          ></v-date-picker>
                        </v-menu>
                      </td>
                      <td class="text-center">
                        <v-icon
                          v-if="(assignedStars[affiliate.userId] || []).length > 1"
                          color="error"
                          class="cursor-pointer"
                          @click="removeCategoryRow(affiliate.userId, index)"
                        >
                          mdi-delete
                        </v-icon>
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>

                <v-btn
                  text
                  small
                  color="primary"
                  class="mt-2"
                  :disabled="!canAddCategory(affiliate.userId)"
                  @click="addCategoryRow(affiliate.userId)"
                >
                  <v-icon left>mdi-plus</v-icon>
                  {{ $t('recognition.button.addCategory') }}
                </v-btn>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </div>

      <v-dialog v-model="dialog" max-width="600px" persistent>
        <v-card class="container-model">
          <v-btn
            icon
            class="close-button"
            @click="closeDialog"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-col cols="12" md="12" sm="6">
            <img
              src="https://ibliss-icons-prod.s3.us-east-1.amazonaws.com/marca_empresarial/image-welcomeDefault.png"
              class="custom-img" lang="logoIbliss"
            />
          </v-col>
          <h2 class="custom-title">{{ $t('starAssignment.label.search') }}</h2>
          <h3 class="custom-text">{{ $t('starAssignment.label.maxAffiliates') }}</h3>
          <br />
          <v-row no-gutters>
            <v-col cols="12" sm="12" md="12" class="seach">
              <v-text-field
                :label="$t('label.search.title')"
                :placeholder="$t('label.search.text')"
                append-icon="mdi-magnify"
                dense
                v-model="searchTerm"
                outlined
                class="seach"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-list v-if="searchTerm" class="scrollable-list">
            <v-list-item-group v-if="filteredAffiliates.length">
              <v-list-item
                v-for="affiliate in filteredAffiliates"
                :key="affiliate.index"
              >
                <v-list-item-action>
                  <v-checkbox
                    v-model="selectedItems"
                    :value="affiliate.userId"
                    color="secondary"
                    @change="toggleAffiliateSelection(affiliate)"
                    :disabled="
                      selectedItems.length >= 10 &&
                      !selectedItems.includes(affiliate.userId)
                    "
                  ></v-checkbox>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title
                    >{{ affiliate.firstName }} {{ affiliate.middleName }}
                    {{ affiliate.lastName }}
                    {{ affiliate.secondLastName }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
            <v-list-item v-else>
              <v-list-item-content>
                <v-list-item-title>
                  {{ $t('starAssignment.label.notFoundAffiliate') }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-container class="selected-affiliates">
            <div v-if="checkedAffiliates.length">
              <h4>{{ $t('starAssignment.label.checkedAffiliates') }}</h4>
              <ul>
                <div class="affiliates-grid">
                  <div class="column">
                    <div class="affiliate-item">
                      <li
                        v-for="affiliate in firstFiveAffiliates"
                        :key="affiliate.emailAddress"
                      >
                        {{ affiliate.firstName }} {{ affiliate.middleName }}
                        {{ affiliate.lastName }} {{ affiliate.secondLastName }}
                      </li>
                    </div>
                  </div>
                  <div class="column">
                    <div class="affiliate-item">
                      <li
                        v-for="affiliate in secondFiveAffiliates"
                        :key="affiliate.firstName"
                      >
                        {{ affiliate.firstName }} {{ affiliate.middleName }}
                        {{ affiliate.lastName }} {{ affiliate.secondLastName }}
                      </li>
                    </div>
                  </div>
                </div>
              </ul>
            </div>
          </v-container>
          <v-card-actions class="justify-center">
            <v-btn
              :disabled="selectedItems.length === 0"
              rounded
              color="primary"
              @click="saveChanges"
            >
              {{ $t('button.confirm') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <template>
        <div v-if="showTable">
          <div style="height: 50px" v-if="this.checkedAffiliates.length > 0">
            <v-btn
              :disabled="!isSendButtonEnabled"
              fixed
              bottom
              right
              rounded
              @click="confirmSubmit()"
              color="primary"
            >
              {{ $t('button.assign') }}
            </v-btn>
          </div>
        </div>
      </template>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import i18n from '@/plugins/i18n';
import Swal from "sweetalert2";

import {
  USERSADMIN_M,
  ACTION_GET_STARASSIGNMENT_SEARCHAFFILIATES,
  GET_STARASSIGNMENT_SEARCHAFFILIATES,
} from "@/views/users_admin/store/types/types.js";

import {
  STARASSIGNMENT_M,
  GET_STATE_LOADING,
  ACTION_POST_STARASSIGNMENT_INDIVIDUAL,
  GET_CARDSLIST,
  ACTION_GET_CARDSlIST,
  GET_STARTYPES_LIST,
} from "@/views/star_assignment/store/types/types.js";

export default {
  props: {
    shapeTypeId: {
      type: Number,
    },
    redeemDate: {
    },
  },

  data() {
    return {
      dialog: false,
      selectedItems: [],
      searchTerm: "",
      affiliates: [],
      showRest: false,
      shapeCount: 0,
      assignedStars: {},
      checkedAffiliates: [],
      selectedAffiliatesData: [],
      confirmDialog: false,
      showTable: false,
      responseService: null,
      globalCustomizeDate: false,
      globalCustomizeShapeType: false,
    };
  },

  async mounted() {
    this.responseService = await this.getCardsList();
  },

  methods: {
    closeDialog() {
      this.searchTerm = "";
      this.dialog = false;
    },

    confirmSubmit() {
      
      if (!this.shapeTypeId) {
        Swal.fire({
          icon: "error",
          title: i18n.t('starAssignment.label.typeStar.required'),
          confirmButtonColor: "#6E17A5",
        });
        return;
      }

      if (!this.redeemDate) {
        Swal.fire({
          icon: "error",
          title: i18n.t('starAssignment.label.date.required'),
          confirmButtonColor: "#6E17A5",
        });
        return;
      }

      Swal.fire({
        title: i18n.t('starAssignment.label.assignStar'),
        icon: "question",
        showCancelButton: true,
        confirmButtonText: i18n.t('button.saveAssign.text'),
        cancelButtonText: i18n.t('button.cancel.text'),
        confirmButtonColor: "#6E17A5",
      }).then((result) => {
        if (result.isConfirmed) {
          try {
            const data = this.sendDataToParent();
            this.postStarAssignmentAll(data);
            this.closeDialog();
            this.$emit("saved", "Los datos se han guardado exitosamente.");
          } catch (error) {
            console.error("Error al guardar los datos:", error);
          }

          this.confirmDialog = false;
        } else {
          Swal.fire({
            position: "top-end",
            icon: "info",
            title: i18n.t('label.delete.cancel'),
            showConfirmButton: false,
            timer: 2500,
          });
        }
      });
    },

    ...mapActions({
      getActionSearchAffiliates: `${USERSADMIN_M}${ACTION_GET_STARASSIGNMENT_SEARCHAFFILIATES}`,
      getCardsList: `${STARASSIGNMENT_M}${ACTION_GET_CARDSlIST}`,
      postStarAssignmentAll: `${STARASSIGNMENT_M}${ACTION_POST_STARASSIGNMENT_INDIVIDUAL}`,
    }),

    getMaxStars(categoryName) {
      const category = this.cardsList.find(
        (card) => card.categoryName === categoryName
      );
      return category ? category.shapeCount : 0;
    },

    toggleAffiliateSelection(affiliate) {
      const index = this.checkedAffiliates.findIndex(
        (a) => a.userId === affiliate.userId
      );
      if (index === -1) {
        this.checkedAffiliates.push(affiliate);
        this.$set(this.assignedStars, String(affiliate.userId), [
          { categoryId: null, categoryName: null, categoryObject: null, quantity: '', redeemDate: null, redeemDateMenu: false, shapeTypeId: null },
        ]);
        const options = this.getCategoryOptions(affiliate.userId, 0);
        if (options.length) this.handleCategoryChange(affiliate.userId, 0, options[0]);
      } else {
        this.checkedAffiliates.splice(index, 1);
        this.$delete(this.assignedStars, affiliate.userId);
      }
    },

    getCategoryOptions(userId, currentIndex) {
      const currentCategoryName = this.assignedStars[userId]?.[currentIndex]?.categoryName;
      return this.cardsList.filter((card) => {
        const usedInOtherRow = this.assignedStars[userId]?.some(
          (entry, idx) => idx !== currentIndex && entry.categoryName === card.categoryName
        );
        return !usedInOtherRow || card.categoryName === currentCategoryName;
      });
    },

    canAddCategory(userId) {
      const entries = this.assignedStars[userId] || [];
      return entries.length < this.cardsList.length;
    },

    addCategoryRow(userId) {
      if (!this.assignedStars[userId]) {
        this.$set(this.assignedStars, String(userId), []);
      }
      this.assignedStars[userId].push({
        categoryId: null,
        categoryName: null,
        categoryObject: null,
        quantity: '',
        redeemDate: null,
        redeemDateMenu: false,
        shapeTypeId: null,
      });
      const newIndex = this.assignedStars[userId].length - 1;
      const options = this.getCategoryOptions(userId, newIndex);
      if (options.length) this.handleCategoryChange(userId, newIndex, options[0]);
    },

    removeCategoryRow(userId, index) {
      this.assignedStars[userId].splice(index, 1);
      if (!this.assignedStars[userId].length) {
        this.$delete(this.assignedStars, userId);
      }
    },

    validateAffiliatesCount(userId, categoryName) {
      if (!categoryName) return;
      const maxStars = this.getMaxStars(categoryName);
      const totalAssignedStars = Object.values(this.assignedStars)
        .flat()
        .filter((star) => star.categoryName === categoryName)
        .reduce((acc, star) => acc + Number(star.quantity || 0), 0);

      if (totalAssignedStars > maxStars) {
        Swal.fire({
          icon: "error",
          title: i18n.t('starAssignment.label.limitAssign.title'),
          text: i18n.t('starAssignment.label.limitAssign.text').replace('maxStars', maxStars)
        });

        const rowIndex = this.assignedStars[userId].findIndex(
          (entry) => entry.categoryName === categoryName
        );
        const exceso = totalAssignedStars - maxStars;
        if (rowIndex !== -1) {
          const currentQty = Number(this.assignedStars[userId][rowIndex].quantity) || 0;
          const newValue = Math.max(0, currentQty - exceso);
          this.$set(this.assignedStars[userId][rowIndex], 'quantity', newValue || '');
        }
      }
    },
    handleCategoryChange(userId, index, categoryObject) {
      if (!categoryObject) return;
      this.$set(this.assignedStars[userId][index], 'categoryId', categoryObject.recognitionCategoryId);
      this.$set(this.assignedStars[userId][index], 'categoryName', categoryObject.categoryName);
      this.$set(this.assignedStars[userId][index], 'categoryObject', categoryObject);
      this.$set(this.assignedStars[userId][index], 'quantity', this.assignedStars[userId][index].quantity || '');
      this.validateAffiliatesCount(userId, categoryObject.categoryName);
      this.applyGlobalFallbacksToEntry(userId, index);
    },

    updateAssignedStars(userId, index, quantity) {
      // Validar y limpiar decimales (punto o coma)
      if (quantity !== "" && quantity !== "0") {
        if (/[.,]/.test(quantity)) {
          quantity = quantity.split(/[.,]/)[0];
        }
      }
      const value = quantity === "" || quantity === "0" ? "" : Number(quantity);
      this.$set(this.assignedStars[userId][index], 'quantity', value);

      this.validateAffiliatesCount(userId, this.assignedStars[userId][index].categoryName);
      this.applyGlobalFallbacksToEntry(userId, index);
    },
    async fetchAffiliates() {
      if (this.searchTerm.length >= 3) {
        try {
          await this.getActionSearchAffiliates(this.searchTerm);
        } catch (error) {
          console.error("Error fetching affiliates:", error);
        }
      }
    },

    saveChanges() {
      const newSelectedAffiliates = this.searchAffiliates.filter((affiliate) =>
        this.selectedItems.includes(affiliate.userId)
      );
      this.selectedAffiliatesData = [
        ...new Set([...this.selectedAffiliatesData, ...newSelectedAffiliates]),
      ];

      this.showTable = true;
      this.dialog = false;
      this.searchTerm = "";
    },

    toggleGlobalCustomizeDate() {
      Object.keys(this.assignedStars).forEach((userId) => {
        this.assignedStars[userId].forEach((entry) => {
          if (entry.categoryName) {
            this.$set(entry, 'redeemDate', this.globalCustomizeDate ? this.redeemDate : null);
          }
        });
      });
    },

    toggleGlobalCustomizeShapeType() {
      Object.keys(this.assignedStars).forEach((userId) => {
        this.assignedStars[userId].forEach((entry) => {
          if (entry.categoryName) {
            this.$set(entry, 'shapeTypeId', this.globalCustomizeShapeType ? Number(this.shapeTypeId) : null);
          }
        });
      });
    },

    applyGlobalFallbacksToEntry(userId, index) {
      const entry = this.assignedStars[userId][index];
      if (!entry.categoryName) return;

      if (this.globalCustomizeDate && !entry.redeemDate) {
        this.$set(entry, 'redeemDate', this.redeemDate);
      }
      if (this.globalCustomizeShapeType && !entry.shapeTypeId) {
        this.$set(entry, 'shapeTypeId', Number(this.shapeTypeId));
      }
    },

    prepareDataForSubmit() {
      return {
        sourceUserId: Number(sessionStorage.getItem('idUsuario')),
        companyId: Number(sessionStorage.getItem('idEmpresa')),
        redeemDate: this.redeemDate,
        shapeTypeId: Number(this.shapeTypeId),
        destinationUsers: Object.keys(this.assignedStars).map((affiliateId) => {
          const categories = this.assignedStars[affiliateId]
            .filter((entry) => entry.categoryId && entry.quantity !== '' && Number(entry.quantity) > 0)
            .map((entry) => {
              const category = {
                categoryId: Number(entry.categoryId),
                monetizedObjectCount: Number(entry.quantity),
                value: entry.categoryObject ? entry.categoryObject.value || null : null,
              };
              if (entry.redeemDate) {
                category.redeemDate = entry.redeemDate;
              }
              if (entry.shapeTypeId) {
                category.shapeTypeId = Number(entry.shapeTypeId);
              }
              return category;
            });
          return {
            destinationUserId: Number(affiliateId),
            categories,
          };
        }).filter((user) => user.categories.length > 0),
      };
    },

    sendDataToParent() {
      const dataForSubmit = this.prepareDataForSubmit();

      if (!dataForSubmit || !Array.isArray(dataForSubmit.destinationUsers)) {
        throw new Error(
          i18n.t('starAssignment.label.errorAssign')
        );
      }

      return dataForSubmit;
    },
  },

  computed: {
    ...mapGetters({
      searchAffiliates: [
        `${USERSADMIN_M}${GET_STARASSIGNMENT_SEARCHAFFILIATES}`,
      ],
      cardsList: `${STARASSIGNMENT_M}${GET_CARDSLIST}`,
      typeStar: [`${STARASSIGNMENT_M}${GET_STARTYPES_LIST}`],
      loading: [`${STARASSIGNMENT_M}${GET_STATE_LOADING}`],
    }),

    filteredAffiliates() {
      if (this.searchTerm.length < 3) {
        return [];
      }
      const searchTerms = this.searchTerm.toLowerCase().split(/\s+/);
      
      return this.searchAffiliates
        .filter((affiliate) => {
          const fullName = `${affiliate.firstName} ${
            affiliate.middleName || ""
          } ${affiliate.lastName} ${
            affiliate.secondLastName || ""
          }`.toLowerCase();
          return searchTerms.every((term) => fullName.includes(term));
        })
        .map((affiliate) => ({
          ...affiliate,
          isSelected:
            this.selectedItems.includes(affiliate.userId) ||
            this.selectedAffiliatesData.some(
              (a) => a.userId === affiliate.userId
            ),
        }));
    },

    selectedAffiliates() {
      return this.searchAffiliates.filter((affiliate) =>
        this.selectedItems.includes(affiliate.userId)
      );
    },

    firstFiveAffiliates() {
      return this.checkedAffiliates.slice(0, 5);
    },
    secondFiveAffiliates() {
      return this.checkedAffiliates.slice(5, 10);
    },

    isAddAffiliateEnabled() {
      return Boolean(this.shapeTypeId) && Boolean(this.redeemDate);
    },

    isSendButtonEnabled() {
      return this.checkedAffiliates.every((affiliate) => {
        const entries = this.assignedStars[affiliate.userId] || [];
        return (
          entries.length > 0 &&
          entries.every(
            (entry) => entry.categoryName && Number(entry.quantity) > 0
          )
        );
      });
    },
  },

  watch: {
    searchTerm(newTerm) {
      if (newTerm.length >= 3) {
        this.fetchAffiliates();
      }
    },
  },
};
</script>

<style scoped>
.individual-assignment {
  padding: 16px 0;
}

.add-affiliate-btn {
  text-transform: none;
}

.affiliate-card {
  border-radius: 16px !important;
  box-shadow: 0 4px 18px rgba(110, 23, 165, 0.1) !important;
}

.affiliate-title {
  color: #6e17a5;
  font-size: 1.1rem;
  font-weight: 600;
  word-break: auto-phrase;
}

.category-table th {
  font-weight: 500;
  font-size: 15px;
}

.category-table td {
  vertical-align: top;
}

.inputCantidad {
  text-align: center;
  width: 80px;
  border: 1px solid #6e17a5;
  border-radius: 8px;
  padding: 6px;
}

.custom-input {
  max-width: 140px;
  margin: 0 auto;
}

.assign-btn-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}

.container-model {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 24px;
  color: #6e17a5;
  border-radius: 20px !important;
  overflow: hidden;
}

.close-button {
  position: absolute;
  top: 12px;
  right: 12px;
  color: #6e17a5 !important;
}

.custom-img {
  width: 150px;
  height: auto;
  display: block;
  margin: 0 auto 12px;
}

.custom-title {
  color: #6e17a5;
  text-align: center;
  font-size: 1.6rem;
  font-weight: 500;
  margin: 8px 0;
}

.custom-text {
  font-size: 15px;
  color: #6e17a5;
  font-weight: 400;
  text-align: center;
  margin: 2px 0 16px;
}

.seach {
  align-items: center;
  width: 100%;
  max-width: 450px;
}

.scrollable-list {
  max-height: 220px;
  width: 100%;
  max-width: 450px;
  overflow-y: auto;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  background-color: #fafafa;
  padding: 4px 0;
}

.scrollable-list .v-list-item {
  border-radius: 8px;
  margin: 2px 8px;
}

.scrollable-list .v-list-item:hover {
  background-color: #f3e5f5;
}

.selected-affiliates {
  margin-top: 16px;
  text-align: left;
  width: 100%;
  max-width: 450px;
}

.selected-affiliates h4 {
  font-weight: bold;
  color: #4a148c;
  text-align: left;
  font-size: 16px;
  margin-bottom: 8px;
}

.affiliates-grid {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  gap: 16px;
}

.cursor-pointer {
  cursor: pointer;
}

@media screen and (max-width: 600px) {
  .custom-title {
    font-size: 24px;
  }

  .custom-text {
    font-size: 14px;
  }

  .v-card-title {
    font-size: 1rem;
  }

  .scrollable-list {
    max-height: 150px;
  }
}
</style>


